module.exports = __webpack_public_path__ + "static/media/Barra1.2b85ef19.gif";